export default function Display({ as: Tag = "h1", size = 40, children, style }) {
  return (
    <Tag style={{
      fontFamily: "var(--display)",
      fontSize: size,
      fontWeight: 400,
      lineHeight: 1.05,
      letterSpacing: -0.3,
      margin: 0,
      color: "var(--ink)",
      fontVariationSettings: "'opsz' 144, 'SOFT' 30",
      ...style,
    }}>{children}</Tag>
  );
}
